import { render, staticRenderFns } from "./admFarmaco.vue?vue&type=template&id=753f9a21&scoped=true&"
import script from "./admFarmaco.vue?vue&type=script&lang=js&"
export * from "./admFarmaco.vue?vue&type=script&lang=js&"
import style0 from "./admFarmaco.vue?vue&type=style&index=0&id=753f9a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753f9a21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VChip,VFlex,VForm,VLayout,VSpacer,VTextField})
